import { length, split } from "ramda";
import { prod } from "application/constants/app-constants";

export default function getFormId(anonymous) {
  let value = "b7d03f08-ace2-4139-89f9-577744102f7b";
  if (prod) {
    const restNumber = anonymous ? 4 : 3;
    const pathnames = split("/", window.location.pathname);
    value = pathnames[length(pathnames) - restNumber];
  }
  return value;
}
